import { Theme as MuiTheme } from '@material-ui/core/styles';
import createZenoMuiTheme from '@serko/zui/es/style/createZenoMuiTheme';
import themeData from '../assets/savi.theme.json';
import { overrides } from './overrides';
import { shortlist, Shortlist } from './shortlistPalette';

declare module '@serko/zui/es/style/theme.d' {
  interface Zeno {
    shortlist?: Shortlist;
  }
  interface ZenoOptions {
    shortlist?: Shortlist;
  }
}

export default function configureMuiTheme(): MuiTheme {
  const t = createZenoMuiTheme(themeData, {
    overrides,
    zeno: {
      shortlist,
    },
  });
  return { ...t };
}
